import React from 'react';
import { Table } from 'react-bootstrap';

const OrderLineExpandedRow = ({ shipmentLine }) => {
  if (!shipmentLine?.length) return null;

  return (
    <div className="table-responsive p-3">
      <Table size="sm" className="mb-0 border">
        <thead className="bg-light">
          <tr>
            <th className="text-nowrap text-start">Shipment Code</th>
            <th className="text-nowrap text-start">Barcode</th>
            <th className="text-nowrap text-center">Status</th>
            <th className="text-nowrap text-end">Price Info (₹)</th>
          </tr>
        </thead>
        <tbody>
          {shipmentLine.map(line => (
            <tr key={line.id}>
              <td className="text-nowrap text-start">{line.shipment_code}</td>
              <td className="text-nowrap text-start">
                {line?.product?.barcode || '-'}
              </td>
              <td className="text-nowrap text-center">
                {line.is_cancelable === true && line.product_batch_id === null
                  ? 'Out of Stock'
                  : line.shipment_line_status_label}
              </td>
              <td className="text-nowrap text-end">
                ₹{line.unit_gross_amount}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default OrderLineExpandedRow;
